import cn from 'classnames';

import type { FC, MouseEventHandler, ReactNode } from 'react';

import './FilterMenuShell.scss';

interface FilterMenuShellProps {
  children: ReactNode;
  className?: string;
  title?: string;
  meta?: ReactNode;
  footer?: ReactNode;
  onMouseDown?: MouseEventHandler<HTMLDivElement>;
}

export const FilterMenuShell: FC<FilterMenuShellProps> = ({
  children,
  className,
  title,
  meta,
  footer,
  onMouseDown,
}) => (
  <div className={cn('FilterMenuShell', className)} onMouseDown={onMouseDown}>
    {(title || meta) && (
      <div className="FilterMenuShell__header">
        {title && <span className="FilterMenuShell__title">{title}</span>}
        {meta && <span className="FilterMenuShell__meta">{meta}</span>}
      </div>
    )}

    <div className="FilterMenuShell__body">{children}</div>

    {footer && <div className="FilterMenuShell__footer">{footer}</div>}
  </div>
);
